import { ASK_AIRA_ENDPOINT } from "./constants";

export const getRuleApi = (request, getAPICallObject) => ({activity, query}) => {
  const url = `${ASK_AIRA_ENDPOINT}/rule_expr/write_rule`;
  return request(
    url,
    getAPICallObject('POST', { query, save: true, activity }),
  );
};

export const updateLikeResultApi =  (request, getAPICallObject) => requestId => {
  const url = `${ASK_AIRA_ENDPOINT}/rule_expr/like`;
  return request(url, getAPICallObject('POST', { requestId }));
};

export const updateDislikeResultApi = (request, getAPICallObject) => (requestId, feedback) => {
  const url = `${ASK_AIRA_ENDPOINT}/rule_expr/dislike`;
  return request(url, getAPICallObject('POST', { requestId, feedback }));
};
